import './amazonGiftCardReturnErrorStep.scss';
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    AMAZON_GIFT_CARD_RETURN_TIPO_PROCESS,
    AMAZON_RETURN_GIFT_VOUCHER_CANCEL,
    AMAZON_RETURN_GIFT_VOUCHER_REINTENTAR
} = require('constants/tagging');

//@utils
const { recordLinkV2, recordProcess } = require("utilities/tagging");
class AmazonGiftCardReturnErrorStep extends React.Component {
    constructor(props) {
        super(props);

        this.handleNavigateToCodigosClick = this.handleNavigateToCodigosClick.bind(this);
        this.handleSecondaryButtonClick = this.handleSecondaryButtonClick.bind(this);
    }

    componentDidMount() {
        recordProcess(
            AMAZON_GIFT_CARD_RETURN_TIPO_PROCESS,
            "paso 2/error",
            {
                descripcionError: formatText("amazonGiftCardReturn-errorTitle"),
                nombrePagina: "cuenta/cheque-regalo-codigos/devolucion paso 2/error"
            },
            true
        );
    }

    handleNavigateToCodigosClick() {
        const customData = ({
            categoriaEvento: "cuenta/cheque-regalo-codigos/devolucion paso 2/error",
            accionEvento: AMAZON_RETURN_GIFT_VOUCHER_REINTENTAR
        });
        recordLinkV2(customData);
        this.props.navigateToCodigos();
    }

    handleSecondaryButtonClick() {
        const customData = ({
            categoriaEvento: "cuenta/cheque-regalo-codigos/devolucion paso 2/error",
            accionEvento: AMAZON_RETURN_GIFT_VOUCHER_CANCEL
        });
        recordLinkV2(customData);
        this.props.history.push('/myprofile/accounts');
    }

    render() {
        const errorMessage = <FormattedText value="amazonGiftCardReturn-errorTitle" />;
        const mainButtonLabel = <FormattedText value="amazonGiftCardReturn-retryButton" />;
        const secondaryButtonLabel = <FormattedText value="common-cancel" />;
        const mainButton = {
            label: mainButtonLabel
        };
        const secondaryButton = {
            label: secondaryButtonLabel
        }

        return (
            <div className="amazon-gift-card-return-error-step col-xs-offset-1 col-xs-10">
                <WizardError
                    errorMessage={errorMessage}
                    mainButton={mainButton}
                    onMainButtonClick={this.handleNavigateToCodigosClick}
                    secondaryButton={secondaryButton}
                    onSecondaryButtonClick={this.handleSecondaryButtonClick}
                >
                    <div className="amazon-gift-card-return-error-step__content">
                        <FormattedText value="amazonGiftCardReturn-errorMessage" />
                        <p className="amazon-gift-card-return-error-step__help-text">
                            <FormattedText value="amazonGiftCard-helpBoxDescription" />
                        </p>
                    </div>
                </WizardError>
            </div>
        );
    }
}

AmazonGiftCardReturnErrorStep.propTypes = {
    history: PropTypes.object.isRequired,
    navigateToCodigos: PropTypes.func.isRequired,
}

module.exports = withRouter(AmazonGiftCardReturnErrorStep);
